module.exports = __webpack_public_path__ + "img/ic_seal.57e7eea3.svg";